import React, {Component} from 'react';
import {  Link } from 'react-router-dom'; 
  
import { base_url} from '../common/Constants';
 


 
class CareerPages extends React.Component{
 
    render()
    { 

       // const banners = JSON.parse(localStorage.getItem("page_banners"));
        const content = JSON.parse(localStorage.getItem("content"));
         
        return (  
        
      <section
        data-v-1294cef4=""
        data-aos="fade-up"
        data-aos-duration="1000"
        className="section-padded aos-init"
      >
        <div data-v-1294cef4="" className="explore-heading aos-init">
          Learn about our Hiring Strategy
        </div>

        <div className="explore" data-v-1294cef4="">
         

         <Link to={base_url+content[26].slug} className="explore-block">
            <img
              data-v-1294cef4=""
              src={content[26].image}
              alt={content[26].title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{content[26].title}<span>{content[26].subtitle}</span></h1>
            </div>
         </Link>

         <Link to={base_url+content[27].slug} className="explore-block">
            <img
              data-v-1294cef4=""
              src={content[27].image}
              alt={content[27].title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{content[27].title}<span>{content[27].subtitle}</span></h1>
            </div>
         </Link>

         <Link
            to={base_url+content[28].slug}
            aria-current="page"
            className="explore-block nuxt-link-exact-active nuxt-link-active"
          >
            <img
              data-v-1294cef4=""
              src={content[28].image}
              alt={content[28].title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{content[28].title}<span>{content[28].subtitle}</span></h1>
              
            </div>
         </Link>
        </div>
      </section>

      
        );
     
}

}

export default CareerPages;